const TIME_ZONES = {
  'America/St_Johns': 'America/St_Johns',
  'America/Halifax': 'America/Halifax',
  'America/Toronto': 'America/Toronto',
  'America/Winnipeg': 'America/Winnipeg',
  'America/Regina': 'America/Regina',
  'America/Edmonton': 'America/Edmonton',
  'America/Vancouver': 'America/Vancouver',
  'America/Whitehorse': 'America/Whitehorse',
  'America/Iqaluit': 'America/Iqaluit',
  'America/Yellowknife': 'America/Yellowknife',
  'Europe/London': 'Europe/London',
  'Europe/Paris': 'Europe/Paris',
  'Europe/Berlin': 'Europe/Berlin',
  'Europe/Moscow': 'Europe/Moscow',
  'Asia/Dubai': 'Asia/Dubai',
  'Asia/Kolkata': 'Asia/Kolkata',
  'Asia/Bangkok': 'Asia/Bangkok',
  'Asia/Singapore': 'Asia/Singapore',
  'Asia/Tokyo': 'Asia/Tokyo',
  'Asia/Shanghai': 'Asia/Shanghai',
  'Australia/Sydney': 'Australia/Sydney',
  'Pacific/Auckland': 'Pacific/Auckland',
  'Africa/Cairo': 'Africa/Cairo',
  'Atlantic/Reykjavik': 'Atlantic/Reykjavik'
};

export { TIME_ZONES };
